<div>

  <br />
  <div class="form-content">
    <p class="red-font">You are not authorized to this application</p>
    @if (reason) {
      <p class="red-font"> - {{reason}}</p>
    }
  </div>

</div>